import TrackingLinesForm from '../../../../components/Main/Tracking/Lines/TrackingLinesForm'
import React from 'react'
import { Modal } from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function TrackingLinesModal(props) {
  const {
    remove,
    submit,
    update,
    visible,
    modalType,
    formRef,
    onCancel,
    removing,
    submitting,
    // isUpdatable,
  } = props
  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'DWG Lines'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          // visible={}
          submit={submit}
          remove={remove}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'Lines'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <TrackingLinesForm ref={formRef} {...props} />
    </Modal>
  )
}

TrackingLinesModal.propTypes = {}
TrackingLinesModal.defaultProps = {}

export default TrackingLinesModal
